export default {
  name: 'BugReport',
  component: () => import(/* webpackChunkName: "base" */ '../views/BugReportView.vue'),
  meta: {
    exclude: false,
    requiresAuth: true
  }
}
